import styled from "styled-components";
import { useTranslation } from "react-i18next";
import themeProps from "theme/themes";
import illustration1 from "assets/illustrations/illustration1.svg";
import illustration2 from "assets/illustrations/illustration2.svg";
import illustration3 from "assets/illustrations/illustration3.svg";
import illustration4 from "assets/illustrations/illustration4.svg";

const Wrapper = styled.div``;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 50px 10vw;
`;
const RowOdd = styled(Row)`
  background-color: ${(props: themeProps) => props.theme.main.primary};
`;

const RowSide = styled.div`
  width: 30%;
`;

const Heading = styled.h2`
  font-weight: 500;
  font-size: 3rem;
  margin-bottom: 16px;
`;
const HeadingOdd = styled(Heading)`
  color: #fff;
`;

const Text = styled.p`
  font-size: 1.3rem;
  line-height: 1.5;
`;
const TextOdd = styled(Text)`
  color: #fff;
`;

const Image = styled.img`
  width: 100%;
  height: 250px;
`;

const Launch = () => {
  const { t } = useTranslation("launchScreen");

  return (
    <Wrapper>
      <RowOdd>
        <RowSide>
          <HeadingOdd>{t("sectionOne.heading")}</HeadingOdd>
          <TextOdd>{t("sectionOne.text")}</TextOdd>
        </RowSide>
        <RowSide>
          <Image src={illustration1} />
        </RowSide>
      </RowOdd>
      <Row>
        <RowSide>
          <Image src={illustration2} />
        </RowSide>
        <RowSide>
          <Heading>{t("sectionTwo.heading")}</Heading>
          <Text>{t("sectionTwo.text")}</Text>
        </RowSide>
      </Row>
      <RowOdd>
        <RowSide>
          <HeadingOdd>{t("sectionThree.heading")}</HeadingOdd>
          <TextOdd>{t("sectionThree.text")}</TextOdd>
        </RowSide>
        <RowSide>
          <Image src={illustration3} />
        </RowSide>
      </RowOdd>
      <Row>
        <RowSide>
          <Image src={illustration4} />
        </RowSide>
        <RowSide>
          <Heading>{t("sectionFour.heading")}</Heading>
          <Text>{t("sectionFour.text")}</Text>
        </RowSide>
      </Row>
    </Wrapper>
  );
};

export default Launch;
